// Modulo de busqueda de sku's
import React , { useState }from 'react'


import Form from 'react-bootstrap/Form';

import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown'

import axios from 'axios';
import getGlobal from '../../setglobal';
import SearchDrop from './SearchDrop';


export default function Search({show}) {

    const [showDrop,setShowDrop] = useState( false ) ;
    const [myData, setMyData] = useState( []) ;

    function onSearchSku(e)
    {
        e.preventDefault() ;

        var sku = document.getElementById( 'buscar').value ;
        console.log( "Nos mandan a buscar " + sku ) ;
        show( { status : true ,
             sku : sku ,
          } ) ;
        
    }

    function onChangeSku( e )
    {
        var sku = document.getElementById( 'buscar').value ;
        console.log( "Nos mandan a buscar " + sku ) ;

        if ( sku.length >= 3 )
        {
           
            // getGlobal() + "getproductrealtime/?sku=" + showProduct.sku
            axios.get( getGlobal() + "getproductrealtime/?sku=" +  sku  )
            .then( (response) => {

                //console.log( response.data ) ;

                setMyData( response.data ) ;
                if ( response.data.length > 0 )
                {
                    setShowDrop( true ) ;
                }
                else{
                    setShowDrop ( false ) ;
                }
                

            } ) 
            .catch( ( err ) => {
                console.log( err ) ;
            })

        }
        else{
            setShowDrop( false )
        }

        //document.getElementById( 'buscar').value = "supertools";
    }

  return (


    <div>
        <div className='row pt-2 '>
            <div className='col-4'></div>
            <div className='col-4'>
                <div >
                    <Form.Control
                        type="text"
                        id="buscar"
                        aria-describedby="buscarBlock"
                        placeholder='Busque herramientas, partes y todo lo que necesite'
                        height={20}
                        onChange={onChangeSku}
                    />
                    <Form.Text id="buscarBlock" >
                    </Form.Text>
                </div>

                {showDrop && (<SearchDrop myData={myData} show={show}></SearchDrop>)}

                
            </div>
            <div className='col-1'>
                {/* <Button ></Button> */}
                
                <FontAwesomeIcon onClick={onSearchSku}  className='pt-2' style={{height:'25px'}} icon={faMagnifyingGlass} />

               
            </div>

            
        
        </div>
    
      {/* <Form.Label htmlFor="inputPassword5">Password</Form.Label> */}

    </div>
  )
}
